import {
  Action,
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';
import { SET_ERROR, SET_IMAGE_UPLOAD, SET_LOADING } from './ui.actions';
import { UIError, UIState, UILoading } from './ui.interface';

export const initialState: UIState = {
  uiError: {} as UIError,
  uiLoading: { isLoading: false } as UILoading,
};

const _uiReducer = createReducer(
  initialState,
  on(SET_ERROR, (state, { uiError }) => {
    return {
      ...state,
      uiError,
    };
  })
);

const _uiLoadingReducer = createReducer(
  initialState,
  on(SET_LOADING, (state, { uiLoading }) => {
    return {
      ...state,
      uiLoading: {
        ...state.uiLoading,
        isLoading: uiLoading.isLoading,
      },
    };
  }),
  on(SET_IMAGE_UPLOAD, (state, { isImageUpload }) => {
    return {
      ...state,
      uiLoading: {
        ...state.uiLoading,
        isImageUpload,
      },
    };
  })
);

export function uiReducer(uiError: UIState | undefined, action: Action) {
  return _uiReducer(uiError, action);
}

export function uiLoadingReducer(
  uiLoading: UIState | undefined,
  action: Action
) {
  return _uiLoadingReducer(uiLoading, action);
}
export const selectUIState = createFeatureSelector<UIState>('uiState');

export const selectUI = createSelector(
  selectUIState,
  (uiState: UIState) => uiState.uiError
);
